import React, { Component } from 'react'
import PreviewHeader from 'components/PreviewHeader'
import { toggleSharePanelOpen } from 'models/ui/actions'
import { func, bool } from 'prop-types'
import { connect } from 'react-redux'
import { compositionType } from 'models/propTypes'
import {
    saveSelectedComposition,
    renameSelectedComposition as renameSelectedCompositionAction,
    saveCompositionBeforeSharing as saveCompositionBeforeSharingAction,
} from 'models/compositions/actions'
import { openBag as openBagAction } from 'models/bag/actions'
import { getSelectedComposition, getIsSaving, getIsModified, getHasSaveError } from 'models/compositions/selectors'
import { getDesigningEnabled } from 'models/ui/selectors'
import { getIsLoggedIn } from 'models/user/selectors'
import { getHasRendered } from 'models/renderer/selectors'
import { getHasAddedToBag } from 'models/bag/selectors'
import { loginNeeded } from 'models/user/actions'
import { TRACK_LOCATION_DESIGN_HEADER, TRACK_LOCATION_SHARE_PANEL } from 'models/tracking/constants'
import { withTranslation } from 'react-i18next'

class PreviewHeaderContainer extends Component {
    constructor(props) {
        super(props)
        this.onWindowClick = this.onWindowClick.bind(this)
        this.onSave = this.onSave.bind(this)
        this.onShareClick = this.onShareClick.bind(this)
        this.rename = this.rename.bind(this)
        this.edit = this.edit.bind(this)
        this.checkEdit = this.checkEdit.bind(this)
        this.onCompositionInputBlur = this.onCompositionInputBlur.bind(this)
        const { t } = props
        this.state = {
            editing: false,
            editName: (props.composition && props.composition.name) || t('design.default composition name'),
        }
    }

    componentDidMount() {
        window.addEventListener('click', this.onWindowClick)
    }

    componentWillUnmount() {
        window.removeEventListener('click', this.onWindowClick)
    }

    onWindowClick() {
        if (this.state.editing) {
            this.onSave()
        }
    }

    onCompositionInputBlur() {
        const { t } = this.props
        const { editName } = this.state
        if (!editName) {
            this.setState({ editName: t('design.default composition name') }, this.onWindowClick())
        }
    }

    onSave() {
        const trackingInfo = {
            SavedFrom: TRACK_LOCATION_DESIGN_HEADER,
        }
        const { editing, editName } = this.state
        const {
            renameSelectedComposition,
            saveComposition,
            composition: { name: compositionName },
        } = this.props
        if (editing) {
            this.setState({ editing: false })
            if (editName !== compositionName) {
                renameSelectedComposition(editName, trackingInfo)
            }
        } else {
            saveComposition(trackingInfo)
        }
    }

    onShareClick() {
        const { toggleSharePanel, saveCompositionBeforeSharing, isLoggedIn, onLoginNeeded } = this.props
        if (isLoggedIn) {
            const trackingInfo = {
                SavedFrom: TRACK_LOCATION_SHARE_PANEL,
            }
            saveCompositionBeforeSharing(trackingInfo)
            toggleSharePanel()
        } else {
            onLoginNeeded()
        }
    }

    checkEdit(e) {
        e.stopPropagation()
        if (e.keyCode === 13) {
            // Enter key pressed, save it
            this.onSave()
        } else if (e.keyCode === 27) {
            // Cancel with Esc
            this.setState({ editing: false })
        }
    }

    rename(e) {
        e.stopPropagation()
        if (!this.state.editing) {
            this.setState({ editing: true, editName: this.props.composition.name })
        }
    }

    edit(e) {
        this.setState({ editName: e.target.value })
    }

    render() {
        const {
            composition,
            designingEnabled,
            isSaving,
            isModified,
            openTryNewRoomModal,
            hasSaveError,
            hasRendered,
            openBag,
            hasAddedToBag,
        } = this.props
        const { editing, editName } = this.state
        return (
            <PreviewHeader
                composition={composition}
                isSaving={isSaving}
                isModified={isModified}
                designingEnabled={designingEnabled}
                onSave={this.onSave}
                onShareClick={this.onShareClick}
                editName={editName}
                editing={editing}
                rename={this.rename}
                edit={this.edit}
                checkEdit={this.checkEdit}
                openTryNewRoomModal={openTryNewRoomModal}
                hasSaveError={hasSaveError}
                hasRendered={hasRendered}
                openBag={openBag}
                hasAddedToBag={hasAddedToBag}
                onCompositionInputBlur={this.onCompositionInputBlur}
            />
        )
    }
}

PreviewHeaderContainer.defaultProps = {
    composition: null,
}

PreviewHeaderContainer.propTypes = {
    composition: compositionType,
    isLoggedIn: bool.isRequired,
    designingEnabled: bool.isRequired,
    isSaving: bool.isRequired,
    isModified: bool.isRequired,
    saveComposition: func.isRequired,
    renameSelectedComposition: func.isRequired,
    toggleSharePanel: func.isRequired,
    saveCompositionBeforeSharing: func.isRequired,
    openTryNewRoomModal: func.isRequired,
    hasSaveError: bool.isRequired,
    hasRendered: bool.isRequired,
    openBag: func.isRequired,
    hasAddedToBag: bool.isRequired,
    onLoginNeeded: func.isRequired,
    t: func.isRequired,
}

const mapStateToProps = (state, props) => ({
    composition: props.composition || getSelectedComposition(state),
    isLoggedIn: getIsLoggedIn(state),
    designingEnabled: getDesigningEnabled(state),
    isSaving: getIsSaving(state),
    isModified: getIsModified(state),
    hasSaveError: getHasSaveError(state),
    hasRendered: getHasRendered(state),
    hasAddedToBag: getHasAddedToBag(state),
})

const mapDispatchToProps = {
    saveComposition: saveSelectedComposition,
    renameSelectedComposition: renameSelectedCompositionAction,
    toggleSharePanel: toggleSharePanelOpen,
    saveCompositionBeforeSharing: saveCompositionBeforeSharingAction,
    openBag: openBagAction,
    onLoginNeeded: loginNeeded,
}

export default connect(mapStateToProps, mapDispatchToProps)(withTranslation()(PreviewHeaderContainer))
